__webpack_require__.p = "https://media-assets.swiggy.com/swiggy-money/_next/";